<template>
  <div class="right">
    <div class="right_title">
      <div class="right_title_ch">今日设备状态</div>
      <div class="right_title_en">Real-time device status</div>
    </div>
    <div class="right_tele">
      <div class="right_tele_left">
        <div class="right_tele_bg">
          <div class="right_tele_img"></div>
          <img
            src="../img/img_electric.png"
            style="width: 44px; height: 44px"
          />
        </div>
        <div class="right_tele_left_tit">大楼今日用电总量</div>
        <dv-digital-flop
          :config="electricAll"
          style="width: 120px; height: 30px"
        />
      </div>
      <div class="right_tele_right">
        <ul>
          <li>
            <img src="../img/img_ele_zm.png" style="width: 22px" />
            <span>照明用电</span>
            <dv-digital-flop
              :config="electricZhaoming"
              style="width: 110px; height: 30px; margin-left: 15px"
            />
          </li>
          <li>
            <img src="../img/img_ele_dl.png" style="width: 22px" />
            <span>动力用电</span>
            <dv-digital-flop
              :config="electricDongli"
              style="width: 110px; height: 30px; margin-left: 15px"
            />
          </li>
          <li>
            <img src="../img/img_ele_kt.png" style="width: 22px" />
            <span>空调用电</span>
            <dv-digital-flop
              :config="electricKongtiao"
              style="width: 110px; height: 30px; margin-left: 15px"
            />
          </li>
        </ul>
      </div>
    </div>

    <div class="right_title">
      <div class="right_title_ch">本月耗电值趋势</div>
      <div class="right_title_en">Power consumption of this month</div>
    </div>
    <div class="right_sline">
      <dv-charts :option="option" />
    </div>

    <div class="right_title">
      <div class="right_title_ch">用电量TOP10</div>
      <div class="right_title_en">Electricity consumption</div>
    </div>
    <div class="right_ttop_cont">
      <div class="right_ttop_item">
        <div class="right_ttop_item_l">
          <div class="right_ttop_item_lword">当月累计</div>
          <dv-digital-flop
            :config="electricLeiji"
            style="width: 120px; height: 30px; margin-left: 20px"
          />
        </div>
        <div class="right_ttop_item_r">
          同比 <span class="right_ttop_item_r_up">30%</span>
        </div>
      </div>
      <div class="right_ttop_item">
        <div class="right_ttop_item_l">
          <div class="right_ttop_item_lword">上月累计</div>
          <dv-digital-flop
            :config="electricPrevLeiji"
            style="width: 120px; height: 30px; margin-left: 20px"
          />
        </div>
        <div class="right_ttop_item_r">
          环比 <span class="right_ttop_item_r_down">20%</span>
        </div>
      </div>
    </div>
    <div class="right_tchart">
      <dv-capsule-chart :config="config" style="width: 400px; height: 220px" />
    </div>
  </div>
</template>

<script>
  // right - 能源监管

  export default {
    name: "BottomTab",
    components: {},
    data() {
      return {
        // 用电总量
        electricAll: {
          number: [13],
          content: "{nt}kwh",
          style: {
            fontSize: 22,
            fill: "#c97c0e",
            fontWeight: "bold",
          },
        },
        // 照明用电
        electricZhaoming: {
          number: [23],
          content: "{nt}kwh",
          style: {
            fontSize: 17,
            fill: "#c97c0e",
            fontWeight: "bold",
          },
        },
        // 动力用电
        electricDongli: {
          number: [23],
          content: "{nt}kwh",
          style: {
            fontSize: 17,
            fill: "#c97c0e",
            fontWeight: "bold",
          },
        },
        // 空调用电
        electricKongtiao: {
          number: [23],
          content: "{nt}kwh",
          style: {
            fontSize: 17,
            fill: "#c97c0e",
            fontWeight: "bold",
          },
        },
        // 累计用电
        electricLeiji: {
          number: [13],
          content: "{nt}kwh",
          style: {
            fontSize: 22,
            fill: "#c97c0e",
            fontWeight: "bold",
          },
        },
        electricPrevLeiji: {
          number: [13],
          content: "{nt}kwh",
          toFixed: 2,
          style: {
            fontSize: 22,
            fill: "#c97c0e",
            fontWeight: "bold",
          },
        },
        option: {
          // 图例
          legend: {
            show: true,
            data: ["耗电量"],
            top: 30,
            textStyle: {
              fontFamily: "Arial",
              fontSize: 13,
              fill: "#fff",
            },
          },
          xAxis: {
            data: [
              "1",
              "4",
              "7",
              "10",
              "13",
              "16",
              "19",
              "22",
              "25",
              "28",
              "31",
            ],
            axisLabel: {
              style: {
                fill: "#fff",
                fontSize: 10,
                rotate: 0,
              },
            },
            axisLine: {
              show: true, // 设置x轴线显示
              style: {
                stroke: "#fff",
                lineWidth: 1,
              },
            },
            axisTick: {
              show: false,
            },
            interval: 2,
          },
          yAxis: {
            // name: "%",
            data: "value",
            nameTextStyle: {
              fill: "#fff",
              fontSize: 10,
            }, // 标题样式
            axisLabel: {
              style: {
                fill: "#fff",
                fontSize: 10,
                rotate: 0,
              },
            },
            axisLine: {
              show: true, //设置y轴线
              style: {
                stroke: "#fff",
                lineWidth: 1,
              },
            },
            splitLine: {
              show: true,
              style: {
                stroke: '#d4d4d4',
                lineWidth: 1,
                type: 'dotted'
              }
              
            },
            axisTick: {
              show: false, // 不显示刻度
            },
          },
          series: [
            {
              name: "耗电量",
              data: [3200, 3250, 3260, 3250, 3285, 2810, 2810, 3210, 3190, 3250, 3220],
              type: "line",
              // smooth: true,
            },
          ],
          color: ["#188DEC"], // 折线颜色
          grid: {
            style: {
              fill: "rgba(0, 0, 0, 0)",
            },
            top: "30px",
            left: "10px",
            right: "10px",
            bottom: "20px",
          },
          linePoint: {
            show: false,
          },
        },
        config: {
          data: [
            {
              name: "3楼",
              value: 5422,
            },
            {
              name: "7楼",
              value: 4158,
            },
            {
              name: "16楼",
              value: 3652,
            },
            {
              name: "20楼",
              value: 3425,
            },
            {
              name: "22楼",
              value: 3021,
            },
          ],
          colors: ["#188dec", "#c97c0e", "#188dec", "#c97c0e", "#188dec"],
          unit: "单位",
          showValue: true,
        },
      };
    },
    mounted() {
      this.updateHandler();
    },
    methods: {
      /* start(){
        setInterval(this.updateHandler, 5000)
      }, */
      updateHandler() {
        /**
         * 只是这样做是无效
         * config指向的内存地址没有发生变化
         * 组件无法侦知数据变化
         */
        this.electricAll.number[0] = 12345;
        this.electricZhaoming.number[0] = 13464;
        this.electricDongli.number[0] = 13234;
        this.electricKongtiao.number[0] = 12665;
        this.electricLeiji.number[0] = 135531;
        this.electricPrevLeiji.number[0] = 121321;

        /**
         * 使用ES6拓展运算符生成新的props对象
         * 组件侦知数据变化 自动刷新状态
         */
        this.electricAll = { ...this.electricAll };
        this.electricZhaoming = { ...this.electricZhaoming };
        this.electricDongli = { ...this.electricDongli };
        this.electricKongtiao = { ...this.electricKongtiao };
        this.electricLeiji = { ...this.electricLeiji };
        this.electricPrevLeiji = { ...this.electricPrevLeiji };
      },
    },
  };
</script>

<style lang="less">
  .right_title {
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    width: 400px;
    font-family: sans-serif;
    display: flex;
    margin: 20px auto 0;
    background: url(../img/bg_rightline.png) center bottom no-repeat;
    .right_title_ch {
      position: relative;
      font-size: 18px;
      letter-spacing: 2px;
      color: #fff;
      font-weight: bold;
      width: 160px;
      flex-shrink: 0;
    }
    .right_title_ch::before {
      position: absolute;
      content: "";
      right: 0;
      top: 10px;
      width: 2px;
      height: 13px;
      background: #b3c4c9;
    }
    .right_title_en {
      font-size: 11px;
      letter-spacing: 1px;
      color: #b3c4c9;
      padding-left: 10px;
    }
  }
  .right_tele {
    width: 400px;
    height: auto;
    overflow: hidden;
    display: flex;
    margin: 20px auto 0;
    .right_tele_left {
      width: 120px;
      .right_tele_bg {
        width: 110px;
        height: 103px;
        text-align: center;
        position: relative;

        .right_tele_img {
          position: absolute;
          top: 0;
          left: 0;
          background: url(../img/bg_electric.png) no-repeat;
          width: 110px;
          height: 103px;
          animation: fadenum 5s linear infinite;
        }
        img {
          width: 44px;
          height: 44px;
          margin-top: 30px;
        }
      }
      .right_tele_left_tit {
        color: #b3c4c9;
        font-size: 13px;
        letter-spacing: 2px;
      }
      .right_tele_left_num {
        width: 110px;
        text-align: center;
        color: #c97c0e;
        font-size: 20px;
        margin-top: 5px;
      }
    }
    .right_tele_right {
      height: auto;
      margin-left: 45px;
      ul,
      li,
      p {
        margin: 0;
        padding: 0;
        list-style-type: none;
      }
      ul {
        li {
          height: 32px;
          line-height: 32px;
          color: #b3c4c9;
          font-size: 13px;
          margin-top: 15px;
          display: flex;
          align-items: center;
          img {
            width: 22px;
            margin: 0px 15px 0 0;
            float: left;
          }
          span {
            font-size: 17px;
          }
        }
      }
    }
  }
  .right_ttop_cont {
    height: auto;
    width: 400px;
    overflow: hidden;
    margin: 0px auto;
    font-family: sans-serif;
    .right_ttop_item {
      height: 33px;
      line-height: 33px;
      margin-top: 14px;
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      .right_ttop_item_l {
        display: flex;
        line-height: 33px;
        align-items: center;
        .right_ttop_item_lword {
          font-size: 17px;
          color: #b3c4c9;
        }
      }
      .right_ttop_item_r {
        font-size: 13px;
        color: #b3c4c9;
        .right_ttop_item_r_up {
          background: url(../img/bg_up.png) left center no-repeat;
          color: #1fb862;
          font-size: 16px;
          padding-left: 12px;
          margin-left: 8px;
        }
        .right_ttop_item_r_down {
          background: url(../img/bg_down.png) left center no-repeat;
          color: #ed7d2f;
          font-size: 16px;
          padding-left: 12px;
          margin-left: 8px;
        }
      }
    }
  }
  .right_sline {
    height: 140px;
    width: 400px;
    overflow: hidden;
    margin: 0px auto;
    font-family: sans-serif;
  }
  .right_tchart {
    height: auto;
    width: 400px;
    overflow: hidden;
    margin: 20px auto 0;
    font-family: sans-serif;
  }
  @keyframes fadenum {
    50% {
      transform: rotate(-100deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }
</style>
